
import * as contentful from 'contentful';


export const client = contentful.createClient({
    space:'riq8hteop4ty',
    accessToken:'mmbBYwV4VKxL-KBXUOnHh6KSJY8W6LdZpC8oFEQroo8'
})